/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiConfiguration, ApiConfigurationParams } from './api-configuration';

import { AppService } from './services/app.service';
import { ContactsService } from './services/contacts.service';
import { ContactDocumentsService } from './services/contact-documents.service';
import { RealEstatesService } from './services/real-estates.service';
import { RealEstateDocumentsService } from './services/real-estate-documents.service';
import { CompaniesService } from './services/companies.service';
import { CompanyDocumentsService } from './services/company-documents.service';
import { EmployeesService } from './services/employees.service';
import { EmployeeDocumentsService } from './services/employee-documents.service';
import { LeadsService } from './services/leads.service';
import { LeadDocumentsService } from './services/lead-documents.service';
import { BiddingsService } from './services/biddings.service';
import { AuditLogsService } from './services/audit-logs.service';
import { SalesService } from './services/sales.service';
import { MembershipService } from './services/membership.service';
import { ScoutingService } from './services/scouting.service';
import { ScoutingDocumentsService } from './services/scouting-documents.service';
import { FileManagerService } from './services/file-manager.service';
import { SchedulerService } from './services/scheduler.service';
import { TodoService } from './services/todo.service';
import { RulesService } from './services/rules.service';

/**
 * Module that provides all services and configuration.
 */
@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [
    AppService,
    ContactsService,
    ContactDocumentsService,
    RealEstatesService,
    RealEstateDocumentsService,
    CompaniesService,
    CompanyDocumentsService,
    EmployeesService,
    EmployeeDocumentsService,
    LeadsService,
    LeadDocumentsService,
    BiddingsService,
    AuditLogsService,
    SalesService,
    MembershipService,
    ScoutingService,
    ScoutingDocumentsService,
    FileManagerService,
    SchedulerService,
    TodoService,
    RulesService,
    ApiConfiguration,
  ],
})
export class ApiModule {
  static forRoot(params: ApiConfigurationParams): ModuleWithProviders<ApiModule> {
    return {
      ngModule: ApiModule,
      providers: [
        {
          provide: ApiConfiguration,
          useValue: params,
        },
      ],
    };
  }

  constructor(@Optional() @SkipSelf() parentModule: ApiModule, @Optional() http: HttpClient) {
    if (parentModule) {
      throw new Error('ApiModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error(
        'You need to import the HttpClientModule in your AppModule! \n' +
          'See also https://github.com/angular/angular/issues/20575'
      );
    }
  }
}
